import {styled, Table as MuiTable, TableBody, TableCell as MuiTableCell, TableRow} from "@mui/material";

const Table = styled(MuiTable)(() => ({
    marginLeft: "4rem",
}));

const TableCell = styled(MuiTableCell)(() => ({
    border: "none",
    padding: "0 1.3rem 0 0",
}));

const OrganizationDataGridDetailPanel = ({row, formatSalary}) => {
    return (
        <Table size="small">
            <TableBody>
                <TableRow>
                    <TableCell align="right" width="180px">Calculated National Rate:</TableCell>
                    <TableCell>{formatSalary(row.nationalRate)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Min/Mid/Max:</TableCell>
                    <TableCell>{formatSalary(row.salaryMin)} / {formatSalary(row.salaryMid)} / {formatSalary(row.salaryMax)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Job Level:</TableCell>
                    <TableCell>{row.jobLevel}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Hours Per Week:</TableCell>
                    <TableCell>{row.hoursPerWeek}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Payment Frequency:</TableCell>
                    <TableCell>{row.paymentFrequency}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Days Holiday:</TableCell>
                    <TableCell>{row.daysHoliday}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Holiday comments:</TableCell>
                    <TableCell>{row.holidayComments}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Shifts and overtime:</TableCell>
                    <TableCell>{row.shifts}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Extras:</TableCell>
                    <TableCell>{row.extras}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Footnote:</TableCell>
                    <TableCell>{row.footnote}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="right">Company-specific Job Title:</TableCell>
                    <TableCell>{row.jobTitle}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default OrganizationDataGridDetailPanel;
